import {
  ADD_CATEGORY,
  ADD_CATEGORY_ERROR,
  ADD_CATEGORY_SUCCESS,
  DELETE_CATEGORY,
  DELETE_CATEGORY_ERROR,
  DELETE_CATEGORY_SUCCESS,
  GET_CATEGORIES,
  GET_CATEGORIES_ERROR,
  GET_CATEGORIES_SUCCESS,
  GET_CATEGORY,
  GET_CATEGORY_SUCCESS,
  UPDATE_CATEGORY,
  UPDATE_CATEGORY_ERROR,
  UPDATE_CATEGORY_SUCCESS,
  UPLOAD_CATEGORY_ICON,
  UPLOAD_CATEGORY_ICON_ERROR,
  UPLOAD_CATEGORY_ICON_SUCCESS,
  GET_CATEGORIES_SELECT_LIST,
  GET_CATEGORIES_SELECT_LIST_SUCCESS,
  GET_CATEGORIES_SELECT_LIST_ERROR,
  TOGGLE_CATEGORY_MODAL,
} from "./actionTypes";

export const getCategories = (request) => {
  return {
    type: GET_CATEGORIES,
    payload: { request },
  };
};

export const getCategoriesSuccess = (paginatedCategories) => {
  return {
    type: GET_CATEGORIES_SUCCESS,
    payload: paginatedCategories,
  };
};

export const getCategoriesError = (message) => {
  return {
    type: GET_CATEGORIES_ERROR,
    payload: message,
  };
};

export const addCategory = (request) => {
  return {
    type: ADD_CATEGORY,
    payload: { request },
  };
};

export const addCategorySuccess = () => {
  return {
    type: ADD_CATEGORY_SUCCESS,
  };
};

export const addCategoryError = (error) => {
  return {
    type: ADD_CATEGORY_ERROR,
    payload: error,
  };
};

export const getCategory = (id) => {
  return {
    type: GET_CATEGORY,
    payload: { id },
  };
};

export const getCategorySuccess = (category) => {
  return {
    type: GET_CATEGORY_SUCCESS,
    payload: category,
  };
};

export const getCategoryError = (message) => {
  return {
    type: GET_CATEGORIES_ERROR,
    payload: message,
  };
};

export const updateCategory = (request) => {
  return {
    type: UPDATE_CATEGORY,
    payload: { request },
  };
};

export const updateCategorySuccess = () => {
  return {
    type: UPDATE_CATEGORY_SUCCESS,
  };
};

export const updateCategoryError = (error) => {
  return {
    type: UPDATE_CATEGORY_ERROR,
    payload: error,
  };
};

export const deleteCategory = (id) => {
  return {
    type: DELETE_CATEGORY,
    payload: { id },
  };
};

export const deleteCategorySuccess = () => {
  return {
    type: DELETE_CATEGORY_SUCCESS,
  };
};

export const deleteCategoryError = (error) => {
  return {
    type: DELETE_CATEGORY_ERROR,
    payload: error,
  };
};

export const uploadCategoryIcon = (icon) => {
  return {
    type: UPLOAD_CATEGORY_ICON,
    payload: { icon },
  };
};

export const uploadCategoryIconSuccess = (icon) => {
  return {
    type: UPLOAD_CATEGORY_ICON_SUCCESS,
    payload: icon,
  };
};

export const uploadCategoryIconError = (error) => {
  return {
    type: UPLOAD_CATEGORY_ICON_ERROR,
    payload: error,
  };
};

export const getCategoriesSelectList = () => {
  return {
    type: GET_CATEGORIES_SELECT_LIST,
  };
};

export const getCategoriesSelectListSuccess = (selectList) => {
  return {
    type: GET_CATEGORIES_SELECT_LIST_SUCCESS,
    payload: selectList,
  };
};

export const getCategoriesSelectListError = (error) => {
  return {
    type: GET_CATEGORIES_SELECT_LIST_ERROR,
    payload: error,
  };
};

export const toggleCategoryModalAction = () => {
  return {
    type: TOGGLE_CATEGORY_MODAL,
  };
};
